import PlatingTabContent from './PlatingTabContent';

export default PlatingTabContent;
